import { render, staticRenderFns } from "./addCollectionDialogBox.vue?vue&type=template&id=73ce9b94&scoped=true"
import script from "./addCollectionDialogBox.vue?vue&type=script&lang=js"
export * from "./addCollectionDialogBox.vue?vue&type=script&lang=js"
import style0 from "./addCollectionDialogBox.vue?vue&type=style&index=0&id=73ce9b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ce9b94",
  null
  
)

export default component.exports